import {createApp} from 'vue';


import Echo from 'laravel-echo';

window.Pusher = require('pusher-js');

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.MIX_PUSHER_APP_KEY,
    cluster: process.env.MIX_PUSHER_APP_CLUSTER,
    forceTLS: true
});

// require('components');

/**
 * Create a fresh Vue application instance and attach it to the page
 */
const app = createApp({})

import Chat from "./componenets/chat/Chat";
import Message from "./componenets/chat/Message";
import UserChat from "./componenets/chat/UserViewer";
import ProviderIndex from "./componenets/providers/Index";
import ProviderSearch from "./componenets/providers/Search";
import PartnerSearch from "./componenets/partners/Search";
import RevealMenu from "./componenets/RevealMenu";
import GuestChat from "./componenets/chat/GuestViewer";
import SetObjective from "./componenets/SetObjective";
import CountyMap from "./componenets/CountyMap";
import Vue3Resize from "vue3-resize";
import "vue3-resize/dist/vue3-resize.css";

app.use(Vue3Resize);

app.component('chat', Chat)
app.component('message', Message)
app.component('user-chat', UserChat)
app.component('provider-index', ProviderIndex)
app.component('provider-search', ProviderSearch)
app.component('partner-search', PartnerSearch)
app.component('reveal-menu', RevealMenu)
app.component('guest-chat', GuestChat)
app.component('set-objective', SetObjective)
app.component('county-map', CountyMap)


app.mount("#app");